/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { ConfigService } from '@xilo-mono/common/config';

@Injectable()
export class CovieService {
  apiUrl = `${this.configService.apiUrl}/covie`;
  launchCovie = new BehaviorSubject<{ id: number }>(null);
  token = localStorage.getItem('token');
  options = {
    headers: { 'x-access-token': this.token },
  };

  constructor(private http: HttpClient, private configService: ConfigService) {}

  triggerCovie(id: number) {
    this.launchCovie.next({ id });
  }

  getCovieMapping(
    covieData: any,
    integrationMappingId: number,
    clientId: any,
    formId: any
  ) {
    const body = {
      covieData,
      integrationMappingId,
      clientId,
      formId,
    };
    console.log(covieData);
    return this.http.post(`${this.apiUrl}/create-form-mappings`, body).pipe(
      map((res) => {
        return res['data'];
      })
    );
  }
}
